import { Clock3, ExternalLink, Heart, MapPin, X } from 'lucide-react'

export default function ShopDetail({ shop, favorite, onFavorite, onClose }) {
  if (!shop) return null

  return (
    <aside className="shop-detail" aria-label={`${shop.name} 상세 정보`}>
      <button className="detail-close" type="button" onClick={onClose} aria-label="상세 정보 닫기">
        <X size={19} />
      </button>
      {shop.images?.length > 0 && (
        <div className="detail-gallery" aria-label={`${shop.name} 사진`}>
          {shop.images.map((image) => (
            <img
              key={image.src}
              src={image.src}
              alt={image.alt}
              loading="lazy"
            />
          ))}
        </div>
      )}
      <div className="shop-detail__content">
        <span className="detail-kicker">BUSAN SELECT / {shop.region}</span>
        <div className="detail-title-row">
          <h2>{shop.name}</h2>
          <button
            className={`detail-heart ${favorite ? 'is-favorite' : ''}`}
            type="button"
            onClick={() => onFavorite(shop.id)}
            aria-label={favorite ? '즐겨찾기 해제' : '즐겨찾기'}
          >
            <Heart size={20} fill={favorite ? 'currentColor' : 'none'} />
          </button>
        </div>
        <p className="detail-description">{shop.description}</p>
        <div className="detail-meta">
          <p><MapPin size={15} />{shop.address}</p>
          <p><Clock3 size={15} />{shop.hours}</p>
        </div>
        <div className="detail-tags">
          <span>{shop.category}</span>
          {shop.tags.map((tag) => <span key={tag}>#{tag}</span>)}
        </div>
        <a
          className="detail-source"
          href={shop.sourceUrl}
          target="_blank"
          rel="noreferrer"
        >
          {shop.sourceLabel}에서 최신 정보 확인
          <ExternalLink size={13} />
        </a>
      </div>
    </aside>
  )
}
